import featureThunkActions from "./featureThunk";

function createExtraReducers() {
  return {
    ...fetchAllowedIds(),
  };

  function fetchAllowedIds() {
    const { fulfilled, rejected, pending } = featureThunkActions.fetchAllowedIds;
    return {
      [pending]: (state) => {
        state.allowedIds.isLoading = true;
        state.allowedIds.error = null;
      },
      [fulfilled]: (state, action) => {
        state.allowedIds.data = action.payload?.ids || [];
        state.businesses = action.payload?.businesses || [];
        state.categories = action.payload?.categories || [];
        state.businessCategories = action.payload?.businessCategories || [];
        state.allowedIds.isLoading = false;
        state.allowedIds.settled = true;
      },
      [rejected]: (state, action) => {
        state.allowedIds.error = action.payload || true;
        state.allowedIds.isLoading = false;
        state.allowedIds.settled = true;
      },
    };
  }
}

const featureExtraReducers = createExtraReducers();
export default featureExtraReducers;
